// Attempt to convert to a number and see if truthy
export const isTruthyNumber = (value: string | undefined) => {
    if (!value) {
        return false;
    }
    return !!parseInt(value);
};
